import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (_jsx("div", { className: "min-h-screen flex items-center justify-center", children: _jsx("div", { className: "text-lg", children: "Loading..." }) }));
    }
    if (!user) {
        return _jsx(Navigate, { to: "/admin/login", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
